import { useEffect } from "react"
import type { MouseEvent } from "react"

import { verifyIntendedPromiseRejection } from "./utils/modal_promise"

import styles from "./diy_add_tanda_button.module.scss"
import { attachNewBadgeForButtons } from "shared/scripts/new_badge_button"

interface Props {
  delayAdded: boolean
  filterCodeAdded: boolean
  onDelayButtonClick: () => void
  onFilterButtonClick: () => void
  onQueryButtonClick: () => void
}

export default function DIYAddFilterQueryButtons({
  delayAdded,
  filterCodeAdded,
  onDelayButtonClick,
  onFilterButtonClick,
  onQueryButtonClick,
}: Props) {
  useEffect(() => {
    attachNewBadgeForButtons()
  }, [])

  // The row is a click target for the mouse; the button carries the action for
  // the keyboard, and a click on it must not run the handler twice.
  const rowClick = (handler: () => void) => (event: MouseEvent<HTMLDivElement>) => {
    if (!(event.target as HTMLElement).closest("button")) verifyIntendedPromiseRejection(handler)()
  }

  return (
    <section className={styles["add-new-query-filter-delay"]}>
      <div className={styles["add-query"]} onClick={rowClick(onQueryButtonClick)}>
        <div className="description">
          <div className={styles.title}>
            <h4 className="text-h2 phone-text-h5">Query</h4>
            <span className={styles.badge} data-allow-new-badge="queries" />
          </div>
          <p className="body-small phone-body-caption">Get additional data from triggers</p>
        </div>
        <button
          type="button"
          className="button-tertiary"
          aria-label="Add query"
          onClick={verifyIntendedPromiseRejection(onQueryButtonClick)}
        >
          Add
        </button>
      </div>
      {filterCodeAdded ? (
        <></>
      ) : (
        <div className={styles["add-filter"]} onClick={rowClick(onFilterButtonClick)}>
          <div className="description">
            <div className={styles.title}>
              <h4 className="text-h2 phone-text-h5">Filter</h4>
              <span className={styles.badge} data-allow-new-badge="filter_code" />
            </div>
            <p className="body-small phone-body-caption">Skip, modify, or personalize actions</p>
          </div>
          <button
            type="button"
            className="button-tertiary"
            aria-label="Add filter"
            onClick={verifyIntendedPromiseRejection(onFilterButtonClick)}
          >
            Add
          </button>
        </div>
      )}
      {delayAdded ? (
        <></>
      ) : (
        <>
          <div className={styles["add-delay"]} onClick={rowClick(onDelayButtonClick)}>
            <div className="description">
              <div className={styles.title}>
                <h4 className="text-h2 phone-text-h5">Delay</h4>
                <span className={styles.badge} />
              </div>
              <p className="body-small phone-body-caption">Add a delay to the next action</p>
            </div>
            <button
              type="button"
              className="button-tertiary"
              aria-label="Add delay"
              onClick={verifyIntendedPromiseRejection(onDelayButtonClick)}
            >
              Add
            </button>
          </div>
        </>
      )}
    </section>
  )
}
